<script setup>
const { $config, $axios } = useNuxtApp()
const sent = ref(false)
const email = ref('')
const emailInput = ref(null)

async function submitEmail() {
  await $axios.post('/api/customer/password-reset/', {
    email: email.value,
  })
  sent.value = true
}

onMounted(() => {
  emailInput.value.$el.querySelector('input').focus()
})
</script>

<template>
  <div>
    <FormKit v-if="!sent" type="form" :actions="false" @submit="submitEmail()">
      <h4>Forgot your password?</h4>
      <p>No problem. We'll email you a link to reset it.</p>
      <FormKit
        ref="emailInput"
        v-model="email"
        type="text"
        name="email"
        label="Email address"
        validation="required|email"
      />
      <FormKit type="submit" label="Submit" />
    </FormKit>
    <div v-if="sent">
      <h4>Password Reset Sent</h4>
      <p>
        If you have a fully registered account with a password, we have sent you
        a reset password email.
      </p>
      <p v-if="$config.public.hasQuickEmailSignup">
        However, if you subscribed solely with an email address and zip code,
        you'll need to check out as a new customer in order to officially
        register your account.
      </p>
      <p>
        If you don't receive an email, please make sure you've entered the email
        address you used to register, and check your spam folder.
      </p>
    </div>
  </div>
</template>
